import { styled } from '@mui/material';

const prefix = 'HusaRenderInput';
const classes = {
  icon: `${prefix}-icon`,
  input: `${prefix}-input`
};
const RenderInputStyled = styled('div')(({ theme }) => ({
  [`& .${classes.icon}`]: {
    position: 'absolute',
    color: theme.palette.action.active,
    bottom: 0,
    '& svg': {
      fontSize: '1.25rem'
    }
  },
  [`& .${classes.input}`]: {
    padding: '0 24px',
    transition: theme.transitions.create('width'),
    width: '100%',
    [theme.breakpoints.up('md')]: {
      width: '30ch'
    }
  }
}));

export { RenderInputStyled, classes };
